module.exports = __webpack_public_path__ + "fonts/PlantinMTPro-Italic.ac930b64.otf";